const splitIntoWords = (camelCaseString?: string) => camelCaseString?.split(/(?=[A-Z])/).join(' ')

export default splitIntoWords
